import {Controller} from "@hotwired/stimulus"

// Freezes the leading columns of a table that scrolls sideways.
//
// Only the first column can be pinned with a fixed offset; every one after it has
// to start where the previous one ends, and that width is decided by the content.
// A hardcoded left drifts the moment a name is longer than expected and leaves a
// strip of scrolling cells showing between two frozen columns — and min-width does
// not help, because table cells ignore it under table-layout: auto.
//
// Mark each cell of a frozen column with data-frozen-column, header included.
export default class extends Controller {
    connect() {
        this.apply()

        // Column widths move with the viewport and with anything that reflows the
        // table, so measure again rather than trusting the first pass.
        this.observer = new ResizeObserver(() => this.apply())
        this.observer.observe(this.element)
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
    }

    apply() {
        const header = this.element.tHead && this.element.tHead.rows[0]
        if (!header) return

        let offset = 0

        for (const cell of header.cells) {
            if (cell.dataset.frozenColumn === undefined) break

            const position = cell.cellIndex + 1
            this.element.querySelectorAll(`tr > :nth-child(${position})`).forEach((column) => {
                if (column.dataset.frozenColumn !== undefined) column.style.left = `${offset}px`
            })

            offset += cell.getBoundingClientRect().width
        }
    }
}
